import React, { useState } from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from "react-router-dom";
import { apiUrl } from "../api_services/api_url";

const LoginPage = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const location = useLocation();

    const handleLogin = async (e) => {
        e.preventDefault();

        if (!email || !password) {
            setError('Please enter your email and password');
            return;
        }

        setLoading(true);
        setError('');

        try {
            const response = await axios.post(`${apiUrl}/kenf/nimrod/login`, { email, password });

            if (response.data.success) {
                localStorage.setItem('accessToken', response.data.access_token);
                localStorage.setItem('refreshToken', response.data.refresh_token);
                navigate(location.state?.from?.pathname || "/");
            } else {
                setError(response.data.message || 'Login failed');
            }
        } catch (err) {
            console.error('Login error:', err);
            setError(err.response?.data?.message || 'An error occurred. Please try again later.');
        }

        setLoading(false);
    };

    return (
        <div
            className="flex items-center justify-center min-h-screen bg-cover bg-center px-4"
            style={{
                backgroundImage: "url('https://img.freepik.com/premium-vector/chat-bot-future-marketing-online-consultation-online-consultation-artificial-intelligence-internet-technology_122058-1365.jpg?uid=R182223404&ga=GA1.1.1503194441.1744391444&semt=ais_hybrid&w=740')",
            }}
        >
            <form
                onSubmit={handleLogin}
                className="w-full max-w-md bg-white bg-opacity-90 rounded-lg shadow-lg p-6 sm:p-8"
            >
                <h1 className="text-2xl sm:text-3xl font-bold mb-6 text-center">Login</h1>

                <div className="mb-4">
                    <label htmlFor="email" className="block text-gray-700 text-sm font-semibold mb-2">
                        Email
                    </label>
                    <input
                        type="email"
                        id="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Enter your email"
                        className="w-full px-4 py-2 border rounded shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
                    />
                </div>

                <div className="mb-4">
                    <label htmlFor="password" className="block text-gray-700 text-sm font-semibold mb-2">
                        Password
                    </label>
                    <input
                        type="password"
                        id="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Enter your password"
                        className="w-full px-4 py-2 border rounded shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
                    />
                </div>

                {error && <p className="text-red-600 text-sm mb-4">{error}</p>}

                <button
                    type="submit"
                    className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 rounded transition duration-300"
                >
                    {loading ? 'Logging in...' : 'Login'}
                </button>
            </form>
        </div>
    );
};

export default LoginPage;
